(() => {
  if (customElements.get('event-product-form')) return;
  class EventProductForm extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-event-variant]');
      this.quantityInput = this.querySelector('[data-event-quantity]');
      this.buttons = this.querySelectorAll('[data-event-buy]');
      this.status = this.querySelector('[data-event-status]');
      this.form.addEventListener('submit', event => this.submit(event));
      this.variantInput.addEventListener('change', () => this.update());
      this.quantityInput.addEventListener('input', () => this.update());
      const params = new URL(location.href).searchParams;
      if (params.has('variant') && (this.variantInput.tagName !== 'SELECT' || [...this.variantInput.options].some(option => option.value === params.get('variant')))) this.variantInput.value = params.get('variant');
      if (/^\d+$/.test(params.get('quantity') || '')) this.quantityInput.value = params.get('quantity');
      this.group = params.get('group') || '';
      this.update();
    }
    get variant() { return this.variantInput.tagName === 'SELECT' ? this.variantInput.selectedOptions[0] : this.variantInput; }
    update() {
      const data = this.variant.dataset;
      const limit = Number(this.dataset.max || 10);
      this.quantityInput.min = '1'; this.quantityInput.step = '1'; this.quantityInput.max = String(limit);
      this.querySelectorAll('[data-event-price]').forEach(el => { el.textContent = data.price; });
      const title = data.title || '';
      this.querySelector('[data-event-summary]').textContent = `${this.quantityInput.value || 0} × ${data.price}${title ? ` · ${title}` : ''}`;
      this.buttons.forEach(button => { button.disabled = this.pending || data.available !== 'true'; });
    }
    async submit(event) {
      event.preventDefault();
      if (this.pending || !window.SBEventFlow || !this.quantityInput.reportValidity()) return;
      this.pending = true; this.update();
      try {
        const config = await window.SBEventFlow.refresh();
        const cart = await new window.SBEventCart.Client(config.root).read();
        const variantId = this.variantInput.value;
        const existing = this.group || cart.items.find(item => item.properties?._sb_event_id === config.eventId && String(item.variant_id) === variantId)?.properties?._sb_ticket_group_id || '';
        const state = { groupId: existing, eventId: config.eventId, variantId, attendees: Array.from({ length: Number(this.quantityInput.value) }, () => ({})) };
        window.SBEventCart.checkBounds(cart, state, config);
        window.SBEventFlow.start(variantId, this.quantityInput.value, existing);
      } catch (error) {
        this.status.textContent = window.SBEventFlow.config.messages[error.code] || window.SBEventFlow.config.messages.network;
        this.status.setAttribute('tabindex', '-1'); this.status.focus();
      } finally { this.pending = false; this.update(); }
    }
  }
  customElements.define('event-product-form', EventProductForm);
})();
